import { Link, useLocation } from 'react-router-dom';
import { Alert, Card } from 'react-bootstrap';

// Shown to logged-out visitors on an item page. The booking / visit API requires an account
// (no guest checkout), so we prompt up-front - both as a slim banner near the top of the page
// and as the call-to-action in the booking column - instead of letting someone fill the form in
// and only discover it from a 401 on submit.
//
// Both links carry the current path as `from` in router state, so Login / Signup send the
// visitor straight back here to continue once they're in. (v6 UX.) Plain <Link>s (styled as
// buttons) rather than <Button as={Link}> so they keep the semantic "link" role.
//
//   <AuthToBook action="request a booking" />              -> full card (booking column)
//   <AuthToBook action="request a booking" as="banner" />  -> slim strip (top of page)
export default function AuthToBook({ action = 'request a booking', as = 'card' }) {
  const location = useLocation();
  const state = { from: `${location.pathname}${location.search}` };

  if (as === 'banner') {
    return (
      <Alert variant="primary" className="d-flex flex-wrap align-items-center gap-2 py-2 mb-3">
        <span className="me-sm-auto">Log in or create an account to {action}.</span>
        <span className="d-flex gap-2">
          <Link to="/login" state={state} className="btn btn-sm btn-primary">
            Log in
          </Link>
          <Link to="/signup" state={state} className="btn btn-sm btn-outline-primary">
            Create account
          </Link>
        </span>
      </Alert>
    );
  }

  return (
    <Card body className="text-center border-primary-subtle">
      <h5 className="mb-1">Log in to {action}</h5>
      <p className="text-muted small mb-3">
        Create a free account or log in to check availability and continue &mdash; you&rsquo;ll
        come right back here.
      </p>
      <div className="d-flex flex-wrap justify-content-center gap-2">
        <Link to="/login" state={state} className="btn btn-primary">
          Log in
        </Link>
        <Link to="/signup" state={state} className="btn btn-outline-primary">
          Create account
        </Link>
      </div>
    </Card>
  );
}
